import { render, staticRenderFns } from "./InfoOrder.vue?vue&type=template&id=3d5f8947&scoped=true"
import script from "./InfoOrder.vue?vue&type=script&lang=js"
export * from "./InfoOrder.vue?vue&type=script&lang=js"
import style0 from "./InfoOrder.vue?vue&type=style&index=0&id=3d5f8947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f8947",
  null
  
)

export default component.exports